import { Provider } from '@angular/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';

// O tooltip é renderizado fora do componente (overlay), então o estilo não pode ficar no SCSS da tela:
// a tela registra um destes providers e os tooltips dela (inclusive os da ui-grid) recebem a classe,
// estilizada em styles/_globais.scss.
const opcoesTooltip = (tooltipClass: string): MatTooltipDefaultOptions => ({
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  tooltipClass,
});

/** Tooltips das grades com texto de 14px. */
export const TOOLTIP_GRADE_PROVIDER: Provider = {
  provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
  useValue: opcoesTooltip('tooltip-grade'),
};

/** Tooltips das grades com texto de 14px e até 400px de largura, com quebra de linha. */
export const TOOLTIP_GRADE_LARGA_PROVIDER: Provider = {
  provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
  useValue: opcoesTooltip('tooltip-grade-larga'),
};
